// extracted by mini-css-extract-plugin
export default {"footer":"AppFooter_footer__WgT7e","name":"AppFooter_name__RmCCL","sep":"AppFooter_sep__Z+xm2","link":"AppFooter_link__fZaK+"};